module.exports = __webpack_public_path__ + "img/secondary_10x3_z16.10ebf409.svg";